import { IconButton, Popover } from "@mui/material";
import type React from "react";
import { useRef, useState } from "react";

import { TestIds } from "@storyboard/web-test-ids/testIds";

export default function HeaderPopover({
  icon,
  children,
  isActive,
  maxHeight = "calc(100vh / 2.5)",
}: {
  icon: React.ReactNode;
  children: React.ReactNode;
  isActive?: boolean;
  maxHeight?: string;
}) {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        ref={anchorRef}
        data-sb={TestIds.driverView.columnFilter}
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        sx={{
          p: 0.25,
          color: isActive || open ? "white" : "rgb(161, 161, 170)",
          bgcolor: isActive ? "#7c3aed" : "transparent",
          borderRadius: 1,
          "&:hover": { color: "white", bgcolor: isActive ? "#7c3aed" : "rgb(63, 63, 70)" },
        }}
      >
        {icon}
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.5,
              bgcolor: "rgb(39, 39, 42)",
              border: "1px solid rgb(113, 113, 122)",
              boxShadow: "0 0 0 4px rgba(0,0,0,0.5)",
              borderRadius: 1,
              maxHeight,
              overflow: "auto",
            },
          },
        }}
      >
        {children}
      </Popover>
    </>
  );
}
